import { View, SxProp, Pressable } from 'dripsy';
import React from 'react';
import { ImageStyle, ViewStyle } from 'react-native';
import { Divider } from '../../Divider';
import { Space } from '../../Space';
import { TextCaption } from '../../typography/UniTypography';

export interface DonutChartLegendItemProps {
  color:
    | string
    | ViewStyle
    | ImageStyle
    | string[]
    | {
        [K: string]: string;
        [I: number]: string;
      }
    | undefined;
  label: string;
  data: Array<string>;
  showValue?: boolean;
  onPress: () => void;
}

export const DonutChartLegendItem: React.FC<DonutChartLegendItemProps> = ({ color, label, data, showValue, onPress }) => {
  const colorIconStyle: SxProp = { ...styles.color, backgroundColor: color as string };

  return (
    <Pressable sx={styles.container} onPress={onPress}>
      <View sx={styles.containerLeft}>
        <View sx={colorIconStyle} />
        <Space width="$2" />
        <TextCaption secondary>{label}</TextCaption>
      </View>
      <View sx={styles.containerRight}>
        {data.map((item, index) => {
          return (
            <React.Fragment key={`donut-chart-legend-item-${item}-${index}`}>
              {index > 0 && <Divider height={16} width={1} sx={{ marginX: 8, marginY: 0 }} />}
              <TextCaption sx={{ width: index > 0 ? 30 : 'auto', whiteSpace: 'nowrap' }}>
                {showValue || index > 0 ? item : '********'}
              </TextCaption>
            </React.Fragment>
          );
        })}
      </View>
    </Pressable>
  );
};

enum StyleName {
  container = 'container',
  containerLeft = 'containerLeft',
  containerRight = 'containerRight',
  color = 'color'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  containerLeft: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  containerRight: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  color: {
    height: 10,
    width: 10,
    borderRadius: 2
  }
};
